import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { produce } from 'immer';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { logger } from '@common/logging/logger';

import { LodGroup } from './types';
import { LOD_GROUPS } from './constants';

type State = {
  lodGroups: LodGroup[];
};

type Actions = {
  setGroupVisibility: (id: string, visible: boolean) => void;
  getGroupVisibility: (tag: string) => boolean | undefined;
  reset: () => void;
};

const INITIAL_STATE: State = {
  lodGroups: LOD_GROUPS,
};

export const useLodStore = create<State & Actions>()(
  devtools(
    (set, get) => ({
      ...INITIAL_STATE,

      setGroupVisibility(id, visible) {
        const group = get().lodGroups.find((item) => item.id === id);
        if (!group) {
          logger.error(`Could not update group with id: ${id}. Not found.`);
          return;
        }

        set(
          produce((state: State) => {
            const groupToUpdate = state.lodGroups.find((item) => item.id === id);
            if (!groupToUpdate) return;

            groupToUpdate.visible = visible;
          }),
          undefined,
          {
            type: 'setGroupVisibility',
          },
        );
      },

      getGroupVisibility(tag) {
        const group = get().lodGroups.find((item) => item.tags.includes(tag));
        if (!group) {
          logger.error(`Could not find group with tag: ${tag}.`);
          return;
        }

        return group.visible;
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'lodStore', ...DEVTOOLS_OPTIONS },
  ),
);
